var exports = {
  "a": "Box__cp4bjq",
};

module.exports = exports;
